module.exports = __webpack_public_path__ + "static/media/queenofbradgate_2.73727c0c.jpg";